import React from "react";

import "./RemovableList.scss";
import { DeleteIcon } from "../../assets";

export type RemovableListProps = {
  cx?: string;
  list: { text: string }[];
  click: any;
};

export const RemovableList: React.FC<RemovableListProps> = ({
  cx = "",
  list,
  click,
}) => {
  return (
    <ol className={`RemovableList ${cx}`}>
      {list.map(({ text }, idx) => (
        <li key={`removable-list-${idx}`}>
          <p>{text}</p>
          <DeleteIcon onClick={(): any => click(idx)} />
        </li>
      ))}
    </ol>
  );
};
